import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { MANUAL_KEYS } from '../reportingFollowUpConstants';
import { AmountInput, RowLabel, SectionCard, TrackingFields, ValuesTable } from './SectionParts';
import styles from '../ReportingFollowUp.module.scss';

const KEYS = MANUAL_KEYS.PERSONAL_NI;

const PersonalNiSection = ({
    ownerName,
    spouseName,
    periodLabel,
    fileNumber,
    autoValues,
    tracking,
    onManualChange,
    onTrackingChange,
    direction,
}) => {
    const { t } = useTranslation();
    const manual = tracking.manualValues || {};
    const hasSpouse = !!spouseName;
    const columns = hasSpouse
        ? [ownerName || t('businessOwnerName'), spouseName]
        : [ownerName || t('businessOwnerName')];

    const manualInput = (key) => {
        const autoFilled = autoValues?.[key] !== undefined && String(manual[key] ?? '') === autoValues[key];
        return (
            <AmountInput
                value={manual[key]}
                onChange={(value) => onManualChange(key, value)}
                className={autoFilled ? styles.autoFilled : ''}
                title={autoFilled ? t('FollowUpAutoFilledFromNi') : undefined}
            />
        );
    };

    return (
        <SectionCard title={t('FollowUpPersonalNiTitle')} fileNumber={fileNumber}>
            <ValuesTable periodLabel={periodLabel} columns={columns}>
                <RowLabel>{t('FollowUpAssessmentDifferencesPayment')}</RowLabel>
                {manualInput(KEYS.ownerAssessmentPayment)}
                {hasSpouse && manualInput(KEYS.spouseAssessmentPayment)}

                <RowLabel>{t('FollowUpCurrentPayment')}</RowLabel>
                {manualInput(KEYS.ownerCurrentPayment)}
                {hasSpouse && manualInput(KEYS.spouseCurrentPayment)}

                <RowLabel>{t('FollowUpInsuredIncome')}</RowLabel>
                {manualInput(KEYS.ownerInsuredIncome)}
                {hasSpouse && manualInput(KEYS.spouseInsuredIncome)}
            </ValuesTable>

            <TrackingFields tracking={tracking} onChange={onTrackingChange} direction={direction} />
        </SectionCard>
    );
};

PersonalNiSection.propTypes = {
    ownerName: PropTypes.string,
    spouseName: PropTypes.string,
    periodLabel: PropTypes.string,
    fileNumber: PropTypes.string,
    /** Manual key → value prefilled from the imported National Insurance file. */
    autoValues: PropTypes.objectOf(PropTypes.string),
    tracking: PropTypes.object.isRequired,
    onManualChange: PropTypes.func.isRequired,
    onTrackingChange: PropTypes.func.isRequired,
    direction: PropTypes.string,
};

export default PersonalNiSection;
